/**
 * Invite warnings returned by the school invite endpoints (D20).
 *
 * `POST /schools/{id}/students/invite`, `POST /schools/{id}/mentors/invite`
 * and each cohort CSV row carry `warning` when the invitee already has an
 * account with an active personal (B2C) subscription. Joining the school
 * does not cancel it, so the school admin is told.
 */
export const ACTIVE_PERSONAL_SUBSCRIPTION_WARNING = 'active_personal_subscription';

type Translate = (key: string, options?: Record<string, unknown>) => string;

/** Localised text for a single-invite warning, or null when there is none. */
export function inviteWarningText(t: Translate, warning: unknown): string | null {
  if (warning === ACTIVE_PERSONAL_SUBSCRIPTION_WARNING) {
    return t('invitePerson.activePersonalSubscriptionWarning');
  }
  return null;
}

/** Invitee-facing text on the accept screen (the admin copy is phrased for the admin). */
export function acceptWarningText(t: Translate, warning: unknown): string | null {
  if (warning === ACTIVE_PERSONAL_SUBSCRIPTION_WARNING) {
    return t('auth.invitation.personalSubscriptionWarning');
  }
  return null;
}

/** Success message with the warning (if any) appended on its own paragraph. */
export function withInviteWarning(t: Translate, message: string, warning: unknown): string {
  const text = inviteWarningText(t, warning);
  return text ? `${message}\n\n${text}` : message;
}

/** Number of CSV rows that came back with the personal-subscription warning. */
export function countPersonalSubscriptionWarnings(
  rows: ReadonlyArray<{ warning?: string | null }>,
): number {
  return rows.filter((row) => row.warning === ACTIVE_PERSONAL_SUBSCRIPTION_WARNING).length;
}
